module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-preface element-with-heading",
    attrs: {
      "epub:type": "preface",
      "id": "preface-2",
      "role": "doc-preface"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "preface-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("I Am the World")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("I cannot argue with pro-self. It either permits or doesn’t. I can, it says, kill any "), _c('i', [_vm._v("mayfly ")]), _vm._v("that endangers the success of the mission, but I cannot do away with them on the grounds that they annoy me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“If they attack me, may I term them all?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Only as many as you must to keep them from damaging us permanently.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I think of something else. “Am I required to maintain any certain standard of living?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It occurs to me that I am eager for these "), _c('i', [_vm._v("mayfly-humans ")]), _vm._v("to do something very, very stupid.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f516a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/iamtheworld.vue
// module id = 75
// module chunks = 0